<template>
  <v-card class="dialog-card">
    <ModalHeader
      helpFileName="UserConfigure"
      icon="mdi-account-plus"
      :modalTitle="'Create User'"
      @close="emit('close')" />
    <v-card-text v-if="new_user">
      <v-text-field
        label="Username"
        v-model="new_user.username"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"></v-text-field>
      <v-text-field
        persistent-hint
        hint="More than 6 characters and contains 1 number or more"
        label="Password"
        type="password"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"
        v-model="new_user.password"></v-text-field>
      <v-text-field
        label="Email"
        v-model="new_user.email"
        bg-color="var(--inner-background) !important"
        color="var(--text) !important"></v-text-field>
      <v-select
        label="Select"
        v-model="new_user.role"
        :items="roleNames"></v-select>
    </v-card-text>

    <div class="modal-footer">
      <v-spacer />
      <v-btn
        style="width: 100%"
        :loading="save_loading"
        :disabled="
          !new_user.username ||
          !new_user.password ||
          !new_user.email ||
          !new_user.role
        "
        @click="CreateCurrentUser()"
        color="primary"
        variant="flat">
        <v-icon class="ml-1 mr-2">mdi-content-save</v-icon>
        Save
      </v-btn>
    </div>
  </v-card>
</template>
<script setup>
import { defineEmits, ref, computed } from 'vue';
import { $http } from '../../stores/http.js';
import { deluge } from '@/stores/deluge.js';
import HelpButton from '../Help-Hints/HelpButton.vue';
import ModalHeader from '../Shared/Modals/ModalHeader.vue';
const roleNames = computed(() =>
  Object.values(deluge.roles || {}).map((r) => r.name)
);
const createuser = ref(undefined);
const save_loading = ref(false);
const new_user = ref({
  username: undefined,
  password: undefined,
  email: undefined,
  role: undefined,
});
const emit = defineEmits(['close']);
function cancelModal() {
  edit_user.value = false;
}
function CreateCurrentUser() {
  if (new_user.value.username == 'admin') {
    alert('Admin account already exists');
  } else {
    let pass = true;
    if (
      new_user.value.password.length < 6 ||
      !/\d/.test(new_user.value.password)
    ) {
      pass = false;
      alert('The password must contain at least 6 characters and one number');
    } else if (!new_user.value.email) {
      pass = false;
      alert('Please enter an email!');
    }
    if (pass) {
      save_loading.value = true;
      $http(
        'POST',
        '/create_new_user?role=' + new_user.value.role,
        JSON.stringify(new_user.value)
      )
        .then((response) => {
          if (response === '"user exists"') {
            alert('User already exists!');
            save_loading.value = false;
          } else if (response === '"email exists"') {
            alert('Email already exists!');
            save_loading.value = false;
          } else {
            save_loading.value = false;
            createuser.value = false;
            emit('close');
          }
        })
        .catch(() => {
          save_loading.value = false;
          alert('Failed to create user!');
        });
    }
  }
}
</script>
